import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'

import {
  Modal,
  Form,
  Input,
  Button,
  Spin,
  Select,
  message,
  Switch,
  Space,
  InputNumber,
  Radio,
} from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: {span: 5},
    sm: {span: 24},
  },
  wrapperCol: {
    md: {span: 16},
  },
}

const formTailLayout = {
  wrapperCol: {
    md: {offset: 5, span: 16},
  },
}

const {TextArea} = Input
const {Option} = Select

export default function ShopAddModal (props) {
  const userData = useSelector(state => state.user.value)
  const metadata = useSelector(state => state.metadata.value)
  const {visible, onOk, onCancel} = props
  const user = useSelector(state => state.user.value)
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [regionOptions, setRegionOptions] = useState([])

  useEffect(() => {
    (async () => {
      try {
        const regionRes = await ToolRequest.request('GET', '/region',{limit:1000})
        const regionOptions = regionRes.data.map(item => {
          return <Option key={item.id}>{item.name[userData.locale]}</Option>
        })
        setRegionOptions(regionOptions)
      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    console.dir(values)
    try {
      let name = {}
      for (let locale of metadata.supportedLocales) {
        name[locale] = values[`name[${locale}]`]
      }
      const data = {
        name,
        address: values.address,
        regionId: values.regionId,
        phone: values.phone,
        isVisible: values.isVisible,
        openHour: values.openHour,
        remark: values.remark,
        shopNo: values.shopNo,
      }
      await ToolRequest.request('POST', `/shop`, data)
      message.success(I18n.t('addSuccessMessage'))
      onOk()
      setLoading(false)
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      }

      message.error(I18n.t('errorMessageUnknownError'))
    }
  }

  return (
    <Modal
      title={I18n.t('添加店鋪')}
      visible={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
            initialValues={
              {
                isVisible:true
              }
            }
            onFinish={onFinish}
          >
            <Form.Item
              label={I18n.t('店號')}
              name="shopNo"
              rules={[
                {
                  required: true,
                  message: I18n.t('errorMessageRequiredInputAny', {
                    name: `${I18n.t('店號')}`,
                  }),
                },
              ]}
            >
              <Input
                placeholder={I18n.t('店號')}
              />
            </Form.Item>
            {metadata.supportedLocales.map(locale => {
              return (
                <Form.Item
                  key={`name[${locale}]`}
                  label={`${I18n.t('名稱')} (${locale})`}
                  name={`name[${locale}]`}
                  rules={[
                    {
                      required: true,
                      message: I18n.t('errorMessageRequiredInputAny', {
                        name: `${I18n.t('名稱')} (${locale})`,
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={`${I18n.t('名稱')} (${locale})`}
                  />
                </Form.Item>
              );
            })}
            <Form.Item
              label={I18n.t('地區')}
              name="regionId"
              rules={[
                {
                  required: true,
                  message: I18n.t('errorMessageRequiredInputAny', {
                    name: `${I18n.t('地區')}`,
                  }),
                },
              ]}
            >
              <Select
                showSearch
                placeholder={I18n.t('地區')}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {regionOptions}
              </Select>
            </Form.Item>
            <Form.Item
              label={I18n.t('營業時間')}
              name="openHour"
            >
              <Input
                placeholder={I18n.t('營業時間')}
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('電話')}
              name="phone"
            >
              <Input
                placeholder={I18n.t('電話')}
              />
            </Form.Item>
            <Form.Item
              label="啟用"
              name="isVisible"
              valuePropName="checked"
            >
              <Switch/>
            </Form.Item>
            <Form.Item
              label={I18n.t('地址')}
              name="address"
            >
            <TextArea
              placeholder={I18n.t('地址')}
            />
            </Form.Item>
            <Form.Item
              label={I18n.t('備註')}
              name="remark"
            >
            <TextArea
              placeholder={I18n.t('備註')}
            />
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull/>}
    </Modal>
  )
};